import {useSuspenseQuery} from "@tanstack/react-query";
import axiosClient from "../axiosClient";
import {handleZodError} from "../handleZodError";
import {DEFAULT_EMPLOYEE_ME, EmployeeMeResModel, IEmployeeMeResModel} from "./dto";

const generateGetEmployeeMe = () => {
	return ["employee", "me"];
};

const fetchGetEmployeeMe = async () => {
	const {data} = await axiosClient.get<IEmployeeMeResModel>("/v1/accounts/employees/me");

	const result = EmployeeMeResModel.model.safeParse(data);

	if (result.success) {
		return result.data;
	} else {
		return handleZodError<IEmployeeMeResModel>({
			error: result.error,
			defaultData: DEFAULT_EMPLOYEE_ME
		});
	}
};

export const useGetEmployeeMe = () => {
	return useSuspenseQuery({
		queryKey: generateGetEmployeeMe(),
		queryFn: fetchGetEmployeeMe,
		staleTime: 1000 * 60 * 10,
		gcTime: 1000 * 60 * 10
	});
};
